module.exports = __webpack_public_path__ + "img/healthIcon.7bd5951b.svg";